(function () {
	angular
		.module('trackeye')
		.factory('AppFactory', AppFactory);

	AppFactory.$inject = ['config'];

	function AppFactory(config) {
		var exports = {},
			assetPath = "assets/",
			imagePath = assetPath + "images/",
			stylePath = assetPath + "style/",
			appCfg = config,
			labelCfg = appCfg.defaults;


		exports.setConfig = function (data) {
			appCfg = data;
			labelCfg = data.defaults;
		};

		/**
		 * Assert if the application is a whitelabel or not
		 * @returns {boolean}
		 */
		exports.isDefault = function () {
			return !!labelCfg.default;
		};

		exports.getDefaultLocale = function () {
			return appCfg.locales.default;
		};

		exports.getAppEventhandlerTemplateId = function () {
			return labelCfg.emails.eventhandler.template;
		};

		exports.getAppEventhandlerProduct = function () {
			return labelCfg.emails.eventhandler.product;
		};

		exports.getAppEventhandlerSender = function () {
			return labelCfg.emails.eventhandler.sender;
		};

		exports.getAppLocales = function () {
			return appCfg.locales.app;
		};

		exports.getEventhandlerEmail = function () {
			return exports.getAppEventhandlerSender() || 'flexserver@appserver.dk'
		}

		exports.appSenders = function () {
			var senders = []
			senders.push(exports.getAppEventhandlerSender() || 'flexserver@appserver.dk')
			
			if (senders.indexOf(labelCfg.emails.support) == -1) {
				senders.push(labelCfg.emails.support)
			}
			return senders.join(', ')
		}

		exports.mailToSupport = function () {
			window.location.href = 'mailto:'+labelCfg.emails.support
		}

		exports.getBackendLocales = function () {
			return appCfg.locales.backend;
		};

		/**
		 * Get application name
		 * @returns {string}
		 */
		exports.getAppName = function () {
			return labelCfg.appName;
		};

		/**
		 *
		 * @param {string} [prepend]
		 * @returns {string|String|*|number}
		 */
		exports.getAppVersion = function (prepend) {
			return prepend ? prepend + appCfg.version : appCfg.version;
		};

		/**
		 * Get simplename, (folders. etc)
		 * @returns {string}
		 */
		exports.getSimpleName = function () {
			return labelCfg.simpleName;
		};

		/**
		 * Get application title
		 * @returns {string}
		 */
		exports.getTitle = function () {
			return labelCfg.title;
		};

		exports.getStylesheet = function () {
			return stylePath + exports.getSimpleName() + ".css" + exports.getAppVersion('?');
		};
		/**
		 * Get path for application logo
		 * @param {string} type
		 * @returns {string|undefined}
		 */
		exports.getLogoPath = function (type) {
			if (!type || !getLogo(type))
				return undefined
			
			return getImagePath() + getLogo(type);
		};

		exports.getLogoLink = function () {
			var logo = labelCfg.logo || {};
			if (!logo.link) {
				return location.origin
			}
			return logo.link;
		}

		/**
		 * Asserts if the application uses seperate authication page
		 * @returns {boolean}
		 */
		exports.hasAuthPage = function () {
			return !!getSettings()['authPage'];
		};

		exports.hasNotification = function() {
			return !!labelCfg.notification
		}

		exports.isNotificationActive = function() {
			if (!exports.hasNotification()) {
				return false
			}

			var activefrom = new Date(getNotification()['activefrom'])
			var activeto = new Date(getNotification()['activeto'])
			var now = new Date()

			if (activefrom <= now && activeto > now) {
				return true
			}
			return false
		}

		exports.getNotificationHead = function() {
			return getNotification()['head']
		}

		exports.getNotificationBody = function() {
			return getNotification()['body']
		}

		exports.getNotificationClass = function() {
			return getNotification()['class']
		}

		exports.hasAddUnit = function() {
			if (getSettings()['addUnit'] === undefined)  {
				return true
			}

			return !!getSettings()['addUnit']
		}

		exports.hasCreateAccount = function () {
			if (getSettings()['createAccount'] === undefined) {
				return true
			}

			return !!getSettings()['createAccount']
		}

		exports.getAuthPage = function () {
			return getSettings()['authPage'];
		};

		/**
		 * Asserts if the application supports migration from old platform
		 * @returns {boolean}
		 */
		exports.hasMigration = function () {
			return !!getSettings()['migration'];
		};

		exports.getContact = function (type) {
			var contact = labelCfg.contact || {};
			return contact[type];
		};

		exports.getApiUrl = function () {
			return appCfg.api.url;
		};

		exports.getMarpleUrl = function () {
			var back = location.origin + '/dashboard/positions'
			return appCfg.marple.url+"/auth?signin=1&back="+encodeURIComponent(back);
		};

		exports.getMarpleShades = function() {
			return appCfg.marple.shades;
		}

		function getNotification() {
			return labelCfg.notification || {};
		}

		function getSettings() {
			return labelCfg.settings || {};
		}

		function getLogo(type) {
			var logo = labelCfg.logo || {};
			return logo[type] || undefined;
		}

		function getImagePath() {
			return imagePath + labelCfg.simpleName + "/";
		}

		return exports;
	}
})();